import { eventTrack } from '@/services/event-track';

export default function(VueInstance) {
  VueInstance.prototype.$eventTrack = eventTrack;
  if (window.analytics) VueInstance.prototype.$analytics = window.analytics;
}
